import { useDispatch, useSelector } from "react-redux";
import { WORKER_PLAN_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { deleteWorkerPlanAction } from "../../../redux/actions/workerPlanAction";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";
import { useState } from "react";
const WorkerCard = ({
  data,
  mode,
  worker,
  cellNumber,
  setOpenConfirmModal,
  setOpenMoreModal,
}) => {
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const workerData = data.worker || data;

  const getDays = (days) =>
    Array.isArray(days)
      ? days
          .map((item) => (typeof item === "object" ? item?.day : item))
          .filter(Boolean)
          .join(", ")
      : "";

  const getHours = (days) =>
    Array.isArray(days)
      ? days
          .map((item) => {
            if (typeof item !== "object") return "";
            const start = item?.startTime || item?.start || "";
            const end = item?.endTime || item?.end || "";
            return start && end ? `${start} - ${end}` : start || end;
          })
          .filter(Boolean)
          .join(", ")
      : "";

  const updateItem = (modalType) => {
    dispatch({
      type: WORKER_PLAN_MODAL_ACTION_TYPE.GET_WORKER_PLAN_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
      },
    });
  };

  const deleteItem = () => {
    dispatch(deleteWorkerPlanAction(data._id));
  };

  const openConfirmModal = () => {
    setOpenConfirmModal(true);
    updateItem("more");
  };

  const openMoreModal = () => {
    updateItem("more");
    setOpenMoreModal(true);
  };

  const doubleClick = () => {
    updateItem("");
  };
  return (
    <>
      {showDeleteModal && (
        <DeleteItemModal
          setShowDeleteModal={setShowDeleteModal}
          deleteItem={deleteItem}
        />
      )}
      {mode === "desktop" ? (
        <tr onDoubleClick={doubleClick}>
          <td>
            <div className="td-con">
              <div className="cell-number">{cellNumber}.</div>
              <div className="table-scroll-text">{workerData.fullName}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">{getDays(data.workDays)}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">{getHours(data.workDays)}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">{getDays(data.leadDays)}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">{getHours(data.leadDays)}</div>
            </div>
          </td>
          {/* <td>
            <div className="td-con">
              <WorkerProfileDropdown data={data} />
            </div>
          </td> */}

          <td>
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              data={data}
              openConfirmModal={openConfirmModal}
              state={worker}
              openMoreModal={openMoreModal}
              setShowDeleteModal={setShowDeleteModal}
            />
          </td>
        </tr>
      ) : (
        <div className="content-box">
          <div className="left">
            <h3>{workerData.fullName}</h3>
            <ul>
              <li>
                <span>Email:</span>
                <p>{workerData.email ? workerData.email : "boş"}</p>
              </li>
              <li>
                <span>Mobil nömrə:</span>
                <p>{workerData.phone ? workerData.phone : "boş"}</p>
              </li>
              <li>
                <span>Pozisiya:</span>
                <p>{workerData.position ? workerData.position : "boş"}</p>
              </li>
              {/* <li>
                <span>Profil:</span>
                <p className="profiles">{profiles}</p>
              </li> */}
            </ul>
          </div>

          <div className="right">
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              data={data}
              openConfirmModal={openConfirmModal}
              state={worker}
              openMoreModal={openMoreModal}
              setShowDeleteModal={setShowDeleteModal}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default WorkerCard;
